var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"c-overlay-fade"}},[(_vm.show)?_c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }